//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import userChecks from '~/mixins/userChecks';
export default {
  mixins: [userChecks],
  async fetch() {
    let query = {
      slug: this.$route.params.slug,
      query: this.queries.category,
    };
    await Promise.all([
      this.$store.dispatch('resourcesStore/getResource', query),
      this.$store.dispatch('bannerStore/getBanner', 'resource'),
      this.$store.dispatch('resourcesStore/countResource', {
        id: this.$route.params.slug,
      }),
    ]);
  },
  head() {
    return {
      title:
        this.category && this.category.seo && this.category.seo
          ? this.category.seo.title
          : +this.$seo.sexfilms.title + ' Categorie | ' + process.env.APP_TITLE,
      meta: [
        {
          hid: 'title',
          name: 'title',
          content:
            this.category && this.category.seo && this.category.seo
              ? this.category.seo.title
              : +this.$seo.sexfilms.title +
                ' Categorie | ' +
                process.env.APP_TITLE,
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content:
            this.category && this.category.seo && this.category.seo
              ? this.category.seo.title
              : +this.$seo.sexfilms.title +
                ' Categorie | ' +
                process.env.APP_TITLE,
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content:
            this.category && this.category.seo && this.category.seo
              ? this.category.seo.title
              : +this.$seo.sexfilms.title +
                ' Categorie | ' +
                process.env.APP_TITLE,
        },
        {
          hid: 'description',
          name: 'description',
          content:
            this.category && this.category.seo && this.category.seo
              ? this.category.seo.description
              : 'Geile categorie van ' +
                process.env.APP_TITLE +
                ' en al de lekkere sexfilms',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content:
            this.category && this.category.seo && this.category.seo
              ? this.category.seo.description
              : 'Geile categorie van ' +
                process.env.APP_TITLE +
                ' en al de lekkere sexfilms',
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content:
            this.category && this.category.seo && this.category.seo
              ? this.category.seo.description
              : 'Geil categorie van ' +
                process.env.APP_TITLE +
                ' en al de lekkere sexfilms',
        },
        {
          hid: 'og:url',
          name: 'og:url',
          content:
            this.category && this.category.slug
              ? process.env.FE_URL +
                '/' +
                this.$seo.categorieen.slug +
                '/' +
                this.category.slug
              : '',
        },
        {
          hid: 'twitter:url',
          name: 'twitter:url',
          content:
            this.category && this.category.slug
              ? process.env.FE_URL +
                '/' +
                this.$seo.categorieen.slug +
                '/' +
                this.category.slug
              : '',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content:
            this.category && this.category.seo && this.category.seo
              ? this.category.seo.keywords
              : +this.$seo.sexfilms.title + ', Categorie',
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content:
            this.category && this.category.images && this.category.images[0]
              ? process.env.CDN + this.category.images[0].sizes.l
              : '',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content:
            this.category && this.category.images && this.category.images[0]
              ? process.env.CDN + this.category.images[0].sizes.l
              : '',
        },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image',
        },
      ],
    };
  },
  components: {
    dummy: () => import('~/components/content/dummy/resource_dummy.vue'),
    thumb: () => import('~/components/thumb'),
    breadcrumbs: () => import('~/components/breadcrumbs'),
    Description: () => import('~/components/DescriptionResources.vue'),
    Readmore: () => import('~/components/Readmore.vue'),
    Favorite: () => import('~/components/FavoriteResources.vue'),
    IncludedVideos: () => import('~/components/IncludedVideos.vue'),
    banner: () => import('~/components/banner.vue'),
    error: () => import('~/components/error.vue'),
  },
  computed: {
    ...mapState({
      queries: ({ resourcesStore: { queries } }) => queries,
      category: ({ resourcesStore: { category } }) => category,
      modal: ({ modalStore: { modal } }) => modal,
      loading: ({ resourcesStore: { loading } }) => loading,
    }),
  },
  methods: {
    toggleModal(type) {
      if (!this.$auth.loggedIn && type == 'favorite') {
        var alertObj = {};
        alertObj.type = 'info';
        alertObj.message =
          'Je kan alleen favorieten toevoegen als je bent ingelogd.';
        return this.$store.commit('alertStore/setAlert', alertObj);
      }
      this.$store.commit('modalStore/setModal', type);
    },
  },
};
